import {z} from 'zod';

import i18n from '@/i18n';
import type {
  CreateJobRoleInput,
  JobRole,
  UpdateJobRoleInput,
} from '@/services/graphqlHooks';

import {JOB_ROLE_COLORS} from './jobRoleColors';

export const jobRoleFormSchema = z.object({
  name: z.string().trim().min(1, i18n.t('Role name is required')),
  color: z.string().trim().min(1, i18n.t('Color is required')),
});

export type JobRoleFormValues = z.infer<typeof jobRoleFormSchema>;

export const jobRoleFormDefaultValues = (
  jobRole?: JobRole
): JobRoleFormValues => ({
  name: jobRole?.name || '',
  color: jobRole?.color || JOB_ROLE_COLORS[0],
});

export const mapJobRoleFormValuesToCreateJobRoleInput = (
  values: JobRoleFormValues
): CreateJobRoleInput => ({
  name: values.name,
  color: values.color,
});

export const mapJobRoleFormValuesToUpdateJobRoleInput = (
  id: string,
  values: JobRoleFormValues
): UpdateJobRoleInput => ({
  id,
  name: values.name,
  color: values.color,
});
